export const PROGRAM_TARGET = {
  ALL: 'all_p1_active',
  SPECIFIC: 'specific_p1',
};

export const PROGRAM_TARGET_LABEL = {
  [PROGRAM_TARGET.ALL]: 'Semua Pemilik P1',
  [PROGRAM_TARGET.SPECIFIC]: 'Pemilik P1 Tertentu',
};

export const STATUS_LABEL = {
  draft: 'Draft',
  scheduled: 'Dijadwalkan',
  active: 'Aktif',
  ended: 'Berakhir',
};
